/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./offset.vue?vue&type=template&id=3984c970&scoped=true"
import script from "./offset.vue?vue&type=script&lang=js"
export * from "./offset.vue?vue&type=script&lang=js"
import style0 from "./offset.vue?vue&type=style&index=0&id=3984c970&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3984c970",
  null
  
)

export default component.exports